import { render } from "./AddContactPage.vue?vue&type=template&id=f9dadee0&ts=true"
import script from "./AddContactPage.vue?vue&type=script&lang=ts"
export * from "./AddContactPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__